module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    ref: "myChart",
    attrs: {
      "width": "50",
      "height": "50"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a246c592","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pie-chart.vue
// module id = 238
// module chunks = 0